var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-wizard-dialog", {
    attrs: {
      title: _vm.$gettext("Seiten verknüpfen"),
      confirmText: _vm.$gettext("Verknüpfen"),
      closeText: _vm.$gettext("Abbrechen"),
      lastRequiredSlotId: 2,
      requirements: _vm.requirements,
      slots: _vm.wizardSlots,
    },
    on: {
      close: function close($event) {
        return _vm.showElementLinkDialog(false)
      },
      confirm: _vm.linkElement,
    },
    scopedSlots: _vm._u([
      {
        key: "unit",
        fn: function fn() {
          return [
            !_vm.loadingUnits
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _vm.hasUnits
                      ? _c(
                          "fieldset",
                          {
                            staticClass: "radiobutton-set",
                          },
                          [
                            _vm._l(_vm.units, function (unit) {
                              return [
                                _c("input", {
                                  key: "radio-" + unit.id,
                                  attrs: {
                                    id: "cw-element-link-unit-" + unit.id,
                                    type: "radio",
                                    "aria-description":
                                      unit.element.attributes.title,
                                  },
                                  domProps: {
                                    checked: unit.id === _vm.selectedUnitId,
                                    value: unit.id,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    key: "label-" + unit.id,
                                    attrs: {
                                      for: "cw-element-link-unit-" + unit.id,
                                    },
                                    on: {
                                      click: function click($event) {
                                        _vm.selectedUnit = unit
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "icon",
                                      },
                                      [
                                        _c("studip-icon", {
                                          attrs: {
                                            shape: "courseware",
                                            size: 32,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(unit.element.attributes.title)
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("studip-icon", {
                                      staticClass: "unchecked",
                                      attrs: {
                                        shape: "radiobutton-unchecked",
                                        size: 24,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("studip-icon", {
                                      staticClass: "check",
                                      attrs: {
                                        shape: "check-circle",
                                        size: 24,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            }),
                          ],
                          2
                        )
                      : _c("courseware-companion-box", {
                          attrs: {
                            mood: "sad",
                            msgCompanion: _vm.$gettext(
                              "Es konnte leider kein Lernmaterial gefunden werden. Bitte erstellen Sie unter Arbeitsplatz/Courseware ein Lernmaterial."
                            ),
                          },
                        }),
                  ],
                  1
                )
              : _c("studip-progress-indicator", {
                  attrs: {
                    description: _vm.$gettext("Lade Lernmaterialien…"),
                  },
                }),
          ]
        },
        proxy: true,
      },
      {
        key: "element",
        fn: function fn() {
          return [
            _vm.selectedUnit
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("courseware-structural-element-selector", {
                      attrs: {
                        rootId: _vm.selectedUnitRootId,
                      },
                      model: {
                        value: _vm.selectedElement,
                        callback: function callback($$v) {
                          _vm.selectedElement = $$v
                        },
                        expression: "selectedElement",
                      },
                    }),
                  ],
                  1
                )
              : _c("courseware-companion-box", {
                  attrs: {
                    mood: "pointing",
                    msgCompanion: _vm.$gettext(
                      "Bitte wählen Sie zuerst das Lernmaterial aus."
                    ),
                  },
                }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }